document.addEventListener('DOMContentLoaded', async () => {
  const blocks = document.querySelectorAll('.brand-block-auto');
  if (!blocks.length) return;

  const moneyFormat = (yen) => `¥${Number(yen).toLocaleString('ja-JP')}`;

  for (const block of blocks) {
    const handle = block.dataset.collectionHandle;
    const displayName = block.dataset.displayName || '';
    const image = block.dataset.image || '';

    if (!handle) continue;

    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!res.ok) throw new Error(`Failed: ${handle}`);

      const data = await res.json();
      const products = data.products || [];

      let minPrice = null;

      products.forEach((product) => {
        product.variants?.forEach((variant) => {
          const price = Number(variant.price);
          if (!Number.isNaN(price)) {
            if (minPrice === null || price < minPrice) {
              minPrice = price;
            }
          }
        });
      });

      const priceHtml =
        minPrice !== null
          ? `<div class="price">${moneyFormat(minPrice)}〜<span>（税込）</span></div>`
          : '';

      block.innerHTML = `
        <div class="thumbnail">
          <div style="background-image:url('${image}')"></div>
        </div>
        <div class="info">
          <div class="title">${displayName}</div>
          <div class="bottom">
            ${priceHtml}
            <a class="link" href="/collections/${handle}">
              <span>詳しく見る</span>
            </a>
          </div>
        </div>
      `;
    } catch (error) {
      console.error(error);
    }
  }
});